import Vue from 'vue'
import Vuex from 'vuex'
import PREPAID_CARD from './PrepaidCard'
import PREPAID_CARD_CHARGE_USED_HISTORY from './PrepaidCardChargeUsedHistory'
import CARWASH_SETTINGS from './CarwashSettings'
import CHARGE_MENU from './ChargeMenu'
import CARWASH_COUPON from './CarwashCoupon'

Vue.use(Vuex)

const { MUTATION } = require('./mutation-types')
const { ACTION } = require('./action-types')

const modules = {
  PREPAID_CARD,
  PREPAID_CARD_CHARGE_USED_HISTORY,
  CARWASH_SETTINGS,
  CHARGE_MENU,
  CARWASH_COUPON
}

const state = {
  modals: []
}

const getters = {
  modals: (state) => {
    return state.modals
  }
}

const actions = {
  [ACTION.OPEN_MODAL] ({ commit }, params) {
    commit(MUTATION.OPEN_MODAL, params)
  },

  [ACTION.CLOSE_MODAL] ({ commit }) {
    commit(MUTATION.CLOSE_MODAL)
  }
}

const mutations = {
  [MUTATION.OPEN_MODAL] (state, modal) {
    state.modals.push(modal)
  },
  [MUTATION.CLOSE_MODAL] (state) {
    state.modals.pop()
  }
}

export default new Vuex.Store({
  modules,
  state,
  getters,
  mutations,
  actions
})
